import { firestore } from "@/firebase";
import { mountContext, splitPath } from "@/store/helpers";
import { CONTEXT_DOC } from "../helpers/getter.type";
export { document_listener } from "../helpers/getters.store";

export const is_watching = state => state.items_listener && state.document_listener ? true : false;

export const items_listener = state => state.items_listener;

export const context_doc = state => ({
  rating_date: state.rating_date,
  goal_deadline: state.goal_deadline,
  template_ref: state.template_ref
});

export const ref = state => firestore.doc(state.ref_path);

export const items = state => state.items;

export const moduleName = state => state.moduleName;

export const single_item = (state, getters) =>
  (cat_id, item_id) => state.items[`/${getters.ref.id}/${cat_id}/${item_id}`]

export const stored_item = (state, getters) =>
  (cat_id, item_id) => Object.keys(state.items).includes(`/${getters.ref.id}/${cat_id}/${item_id}`)

export const stored = (state, getters, rootState, rootGetters) =>
  getters.is_watching && rootGetters["templates/stored"](state.moduleName)

export const cached = (state, getters, rootState, rootGetters) => {
  // if (!getters.stored) return null;
  return mountContext(getters[CONTEXT_DOC], state.items, rootGetters["templates/template"](state.moduleName));
}

export const items_set = state => !state.no_items

export const path = (state, getters) =>
  (cat_id, item_id) => `/${getters.ref.id}/${cat_id}/${item_id}`

export const access = state =>
  path => {
    const parts = splitPath(path);
    let obj = state;
    for (const part of parts) obj = obj[part];
    return obj;
  }